import NodeDetail from './NodeDetail';

export default function EntityDetail() {
  return (
    <NodeDetail
      breadcrumbConfig={{
        parentLabel: 'Entities',
        parentPath: '/develop/semantic-layer/entities',
      }}
      sidebarNodeFilter="entities"
    />
  );
}
